<template>
  <b-tabs
    :model-value="value"
    :animated="animated"
    :destroy-on-hide="destroyOnHide"
    :position="position"
    :size="size"
    :expanded="expanded"
    @update:model-value="onInput"
  >
    <slot />
  </b-tabs>
</template>
<script>
export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'TabsView',
  emits: ['input'],
  props: {
    value: {
      type: [String, Number, null],
      default: undefined
    },
    animated: {
      type: Boolean,
      default: true
    },
    destroyOnHide: {
      type: Boolean,
      default: false
    },
    position: {
      type: String
    },
    size: {
      type: String
    },
    expanded: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onInput(...args) {
      this.$emit('input', ...args);
    }
  }
};
</script>
